<template>
  <div>
    <div>
      <span class="xbed-sub-title">清洁单附属费用设置</span>
    </div>
    <div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>清洁单附属费用设置</BreadcrumbItem>
			</Breadcrumb>
		</div>
    <br>
    <Tabs style="width:1628px;" @on-click="handleTabs" v-model="currentTab">
      <TabPane label="布草洗涤费" name="1">
        <cloth-washing-fee v-if="currentTab === '1'"></cloth-washing-fee>
      </TabPane>
      <TabPane label="易耗品费" name="2">
        <consumables-fee v-if="currentTab === '2'"></consumables-fee>
      </TabPane>
      <TabPane label="操作记录" name="3">
        <operate-record v-if="currentTab === '3'"></operate-record>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import clothWashingFee from './cloth-washing-fee'
import consumablesFee from './consumables-fee'
import operateRecord from './operate-record'

export default {
  data () {
    return {
      currentTab: '1'
    }
  },

  components: {
    clothWashingFee,
    consumablesFee,
    operateRecord
  },

  methods: {
    // 切换tabs
    handleTabs (name) {
      this.currentTab = name
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cleaner/additional-fee/index.vue